import { useMutation, useQueryClient } from '@tanstack/react-query'
import { archivePatient } from '../api/patients'

export function useArchivePatient() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: archivePatient,
    onSuccess: (updatedPatient) => {
      // Update the individual patient cache
      queryClient.setQueryData(['patient', updatedPatient.id], updatedPatient)
      // Invalidate the patients list
      queryClient.invalidateQueries({ queryKey: ['patients'] })
    },
  })
}
